import { CountryCode, getCountryCallingCode } from 'libphonenumber-js';
import metadata from 'libphonenumber-js/metadata.min.json';
import countries from 'i18n-iso-countries';
import koLocale from 'i18n-iso-countries/langs/ko.json';
import enLocale from 'i18n-iso-countries/langs/en.json';
import i18next from 'i18next';

countries.registerLocale(enLocale);
countries.registerLocale(koLocale);

interface getCountryNameByCodeProps {
  contactCountryCode: string;
  countryCode: string;
}
export const getCountryNameByCode = ({
  contactCountryCode,
  countryCode,
}: getCountryNameByCodeProps): string => {
  // ISO 국가코드가 있으면 최우선 사용 => 전화 국가 코드 +1 을 사용하는 국가가 많은 이슈가 발생되어 별도 적용
  if (countryCode) {
    const countryName = countries.getName(countryCode, i18next.language);
    if (countryName) return countryName;
  }

  // 없으면 전화 국가코드로 fallback
  const numericCode = contactCountryCode.replace('+', '');
  const countryCodes = Object.keys(metadata.countries) as CountryCode[];

  for (const country of countryCodes) {
    if (getCountryCallingCode(country) === numericCode) {
      const name = countries.getName(country, i18next.language);
      if (name) return name;
    }
  }

  return '';
};
